// OCR Test Suite — service wrappers over the shared AxiosInstance
// (PLAN-ocr-test-suite.md §7 — no second axios client; admin interceptor returns
// the full response, so callers read response.data.data / response.data.message).
//
// Request/response shapes mirror
// backend/src/testSuite/server-routes/ocrTestSuite.controller.ts (Stage 2).

import axiosInstance from "../AxiosInstance";
import {
  LIST_CASES,
  CREATE_CASE,
  UPDATE_CASE,
  PRESIGN_FIXTURE_UPLOAD,
  RUN,
  LIST_RUNS,
  GET_RUN,
  APPROVE_RUN,
  DIFF_RUNS,
  LIST_COMPANIES,
  CREATE_COMPANY,
  UPDATE_COMPANY,
  SEARCH_COMPANIES,
} from "./OcrTestSuiteEndpoints";

const qs = (params) => {
  const parts = Object.entries(params || {})
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
  return parts.length ? `?${parts.join("&")}` : "";
};

// ── test cases ──────────────────────────────────────────────────────────────
export function listCases({ regionCode, isActive, ocrTestCompanyId } = {}) {
  return axiosInstance.get(LIST_CASES + qs({ regionCode, isActive, ocrTestCompanyId }));
}

export function createCase(payload) {
  // payload: { name, description?, regionCode?, ocrTestCompanyId, fileUrl?, scenarioTag?, expected?, toleranceOverrides? }
  return axiosInstance.post(CREATE_CASE, payload);
}

export function updateCase(id, patch) {
  return axiosInstance.put(`${UPDATE_CASE}/${id}`, patch);
}

// ── fixture upload ──────────────────────────────────────────────────────────
export function presignFixtureUpload({ filename, contentType, ocrTestCompanyId }) {
  return axiosInstance.post(PRESIGN_FIXTURE_UPLOAD, {
    filename,
    contentType,
    ocrTestCompanyId,
  });
}

// Direct S3 PUT of the file bytes to the presigned uploadUrl (mirrors mobile's
// ImageUpload.js addPhoto step 2). Not the shared AxiosInstance — a bare PUT with
// no auth header and the file's own content type.
export function putFileToS3(uploadUrl, file) {
  return fetch(uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file,
  });
}

// ── runs ────────────────────────────────────────────────────────────────────
export function run(body) {
  // body: one of { caseId } | { caseIds: [] } | { region }
  return axiosInstance.post(RUN, body);
}

export function listRuns({ testCaseId, status, regionCode, limit } = {}) {
  return axiosInstance.get(LIST_RUNS + qs({ testCaseId, status, regionCode, limit }));
}

export function getRun(id) {
  return axiosInstance.get(`${GET_RUN}/${id}`);
}

export function approveRun(id) {
  return axiosInstance.post(`${APPROVE_RUN}/${id}/approve`, {});
}

export function diffRuns(runIdA, runIdB) {
  return axiosInstance.post(DIFF_RUNS, { runIdA, runIdB });
}

// ── test companies ─────────────────────────────────────────────────────────
export function listCompanies() {
  return axiosInstance.get(LIST_COMPANIES);
}

export function createCompany({ regionCode, label, companyId, taxLookup }) {
  return axiosInstance.post(CREATE_COMPANY, { regionCode, label, companyId, taxLookup });
}

export function updateCompany(id, patch) {
  return axiosInstance.put(`${UPDATE_COMPANY}/${id}`, patch);
}

export function searchCompanies(q) {
  return axiosInstance.get(SEARCH_COMPANIES + qs({ q }));
}
